import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import OfferSection from '@/pages/home/components/OfferSection';
import GallerySection from '@/pages/home/components/GallerySection';
import VideoSection from '@/pages/home/components/VideoSection';
import BenefitsSection from '@/pages/home/components/BenefitsSection';
import ShareSection from '@/pages/home/components/ShareSection';
import StatsSection from '@/pages/home/components/StatsSection';
import FaqSection from '@/pages/home/components/FaqSection';
import CtaSection from '@/pages/home/components/CtaSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <OfferSection />
        <GallerySection />
        <VideoSection />
        <BenefitsSection />
        <ShareSection />
        <StatsSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}